import customAxios from '../utilities/axios/customAxios';
import onSuccess from './onSuccess';
import { propertyServiceBaseURL } from '../config';

export const getComments = (id: string) =>
  customAxios.get<any>(`${propertyServiceBaseURL}comments/property/${id}`, {
    headers: { surveyId: id },
  }).then(onSuccess);

export const postComment = (id: string, comment: any, setPostResponse: Function) => {
  customAxios
    .post<any>(
      `${propertyServiceBaseURL}comments`,
      comment, {
        headers: { surveyId: id },
      },
    ).then((response: any) => setPostResponse(response.data));
};
